import styled from 'styled-components';
import { Theme } from '@cubeyou-team/hx-theme';

export const StyledDemographicsItem = styled.div<{
  theme: Theme;
  isDragging?: boolean;
}>`
  text-align: center;
  position: relative;
  cursor: pointer;
  padding: ${props => props.theme.spacing.small};
  margin-right: ${props => props.theme.spacing.small};
  margin-bottom: ${props => props.theme.spacing.medium};
  box-shadow: ${props => props.theme.shadow.position}
    ${props => props.theme.shadow.color};
  background-color: ${props => props.theme.colors.light};
  border-radius: ${props => props.theme.border_radius.standard};
  flex-basis: 30%;
  border-width: 2px 2px 2px 6px;
  border-style: solid;
  border-color: ${props =>
    props.isDragging ? props.theme.colors.secondary : 'transparent'};

  img {
    pointer-events: none;
  }
`;

export const StyledDraggableIcon = styled.div<{ theme: Theme }>`
  position: absolute;
  top: ${props => props.theme.spacing.small};
  left: 0;
`;
